// extracted by mini-css-extract-plugin
export default {"main":"tutorial_main__bgN4s","ps":"tutorial_ps__Xc8y5"};